// Onboarding links (the path after the domain, e.g. 'pl_value') where the CookieYes tag in GTM must not fire
export const COOKIEYES_DISABLED_LANDINGS: string[] = [
  'fastpay_g',
  'lp17ch17pr3_h_fastpay2',
  'lp17ch17pr3_h_fastpay2_blck',
  'pl_value',
];
